var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-570"},[_vm._v("支付完成")])}
var staticRenderFns = []

export { render, staticRenderFns }